import { Modal, Select, Tooltip } from "antd";
import { ChevronRight, CircleDollarSign, RefreshCw } from "lucide-react";
import React, { useCallback, useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";
import { getModuleAccessInfoApi } from "../api/candidate";
import Utils from "../utils/Utils";
import WebUtils from "../utils/WebUtils";

function SidebarCreditsCard({ onViewCredits, settingsBasePath, collapsed = false }) {
  let userDetail = Utils.getUserDetail();
  const [organizationList, setOrganizationList] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [activePlan, setActivePlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [searchParams] = useSearchParams();

  const tab = searchParams.get("tab");
  const clientId = searchParams.get("clientId");

  // useEffect(() => {
  //   if (tab !== "billing" || !clientId) return;

  //   const organizationExists = organizationList.some(
  //     (organization) => organization.clientIdentifier === clientId,
  //   );

  //   if (organizationExists) {
  //     setSelectedOrganization(clientId);
  //     getActivePlanDetails(clientId);
  //   }
  // }, [tab, clientId, organizationList]);
  useEffect(() => {
    getActivePlanDetails();
  }, []);

  const getActivePlanDetails = useCallback((clientIdentifier) => {
    // if (!clientIdentifier) {
    //   setActivePlan(null);
    //   setLoading(false);
    //   return;
    // }

    setLoading(true);
    setError(false);
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    WebUtils.httpOperations(url, {}, "GET").then(
      (response) => {
        setLoading(false);
        // console.log(response.data.data);
        if (response?.data?.resultStatusInfo?.resultCode === "SUCCESS") {
          setActivePlan(response?.data?.data || null);
        } else {
          setActivePlan(null);
          setError(true);
        }
      },
      (requestError) => {
        setLoading(false);
        setActivePlan(null);
        setError(true);
        console.error(requestError);
      },
    );
  }, []);

  // const getOrganizationList = useCallback(
  //   (preferredOrganization = "") => {
  //     setLoading(true);
  //     setError(false);

  //     WebUtils.httpOperations(
  //       `${hirePPBaseURl}/account/getOrganizationList`,
  //       {},
  //       "GET",
  //     ).then(
  //       (response) => {
  //         if (response?.data?.resultStatusInfo?.resultCode === "SUCCESS") {
  //           const organizations = [...(response?.data?.data || [])].reverse();
  //           const nextOrganization =
  //             organizations.find(
  //               (organization) =>
  //                 organization.clientIdentifier === preferredOrganization,
  //             )?.clientIdentifier ||
  //             organizations[0]?.clientIdentifier ||
  //             "";

  //           setOrganizationList(organizations);
  //           setSelectedOrganization(nextOrganization);
  //           getActivePlanDetails(nextOrganization);
  //         } else {
  //           setLoading(false);
  //           setOrganizationList([]);
  //           setActivePlan(null);
  //           setError(true);
  //         }
  //       },
  //       (requestError) => {
  //         setLoading(false);
  //         setOrganizationList([]);
  //         setActivePlan(null);
  //         setError(true);
  //         console.error(requestError);
  //       },
  //     );
  //   },
  //   [getActivePlanDetails],
  // );

  // useEffect(() => {
  //   getOrganizationList();
  // }, [getOrganizationList]);

  const handleOrganizationChange = (clientIdentifier) => {
    setSelectedOrganization(clientIdentifier);
    getActivePlanDetails(clientIdentifier);
  };

  const isCreditExpired = (dateValue) => {
    if (!dateValue) return false;

    const expiryDate = new Date(dateValue);

    if (Number.isNaN(expiryDate.getTime())) return false;

    return expiryDate.getTime() < Date.now();
  };

  const formatValidityDate = (dateValue) => {
    if (!dateValue) return "Validity unavailable";

    const date = new Date(dateValue);

    if (Number.isNaN(date.getTime())) {
      return "Validity unavailable";
    }

    return `Valid until ${date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })}`;
  };

  const creditExpired = isCreditExpired(activePlan?.creditExpiryDate);

  const isPlanActive =
    activePlan?.creditExpiryDate &&
    new Date(activePlan.creditExpiryDate).setHours(23, 59, 59, 999) >=
      Date.now();

  const creditItems = [
    { label: "Mock Interview", value: activePlan?.mockInterviewCredits },
    { label: "Resume Match", value: activePlan?.aiResumeMatchCredits },
    {
      label: "Answer Submission",
      value: activePlan?.answerSubmissionCredits,
    },
    { label: "Preparation Guides", value: activePlan?.credits },
  ];

  const renderCreditValue = (value) => {
    if (loading) {
      return <span className="sidebar-credit-skeleton" aria-hidden="true" />;
    }

    if (value === null || value === undefined) {
      return <span className="sidebar-credit-value">--</span>;
    }

    const numericValue = Number(value);
    if (numericValue <= 0) {
      return <span className="sidebar-credit-alert exhausted">EXHAUSTED</span>;
    }

    if (numericValue <= 3) {
      return (
        <span className="sidebar-credit-alert running-low">
          RUNNING LOW: {numericValue}
        </span>
      );
    }

    return <span className="sidebar-credit-value">{value}</span>;
  };

  const renderModalCreditValue = (value) => {
    if (loading) {
      return (
        <span
          className="w-8 h-4 rounded-md bg-gray-200 animate-pulse"
          aria-hidden="true"
        />
      );
    }

    if (value === null || value === undefined) {
      return <span className="font-semibold text-gray-700 text-[0.95rem]">--</span>;
    }

    const numericValue = Number(value);
    if (numericValue <= 0) {
      return (
        <span className="px-2 py-0.5 rounded text-[0.75rem] font-bold text-red-700 bg-red-100">
          EXHAUSTED
        </span>
      );
    }

    if (numericValue <= 3) {
      return (
        <span className="px-2 py-0.5 rounded text-[0.75rem] font-bold text-amber-700 bg-amber-100">
          RUNNING LOW: {numericValue}
        </span>
      );
    }

    return (
      <span className="font-bold text-gray-900 text-[1rem] tabular-nums">
        {value}
      </span>
    );
  };

  if (collapsed) {
    return (
      <div className="my-2 flex justify-center">
        <Tooltip
          color="white"
          overlayInnerStyle={{ color: "black", fontSize: "0.8rem" }}
          placement="right"
          title="Credits"
        >
          <button
            type="button"
            onClick={() => {
              setIsModalOpen(true);
              getActivePlanDetails();
            }}
            className="w-10 h-10 rounded-lg text-[#F2F8FE] hover:bg-white/[0.07] flex items-center justify-center transition-colors duration-150 cursor-pointer group"
            aria-label="Remaining Credits"
          >
            <CircleDollarSign
              size={18}
              strokeWidth={1.7}
              className="transition-transform duration-150 group-hover:scale-110"
            />
          </button>
        </Tooltip>

        <Modal
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          centered
          width={420}
          title={
            <div className="flex items-center gap-3">
              <span className="p-2 rounded-xl border border-amber-200 bg-amber-50 text-amber-600">
                <CircleDollarSign size={20} />
              </span>
              <span className="font-semibold text-gray-900 text-[1.1rem]">
                Remaining Credits
              </span>
            </div>
          }
        >
          <div className="mt-5 mb-2 divide-y divide-gray-100 border-[1px] border-gray-200 rounded-xl bg-gray-100/60 p-2">
            {creditItems.map((credit) => (
              <div
                className="flex items-center justify-between py-3 px-3"
                key={credit.label}
              >
                <span className="text-[0.95rem] font-medium text-gray-600">
                  {credit.label}
                </span>
                {renderModalCreditValue(credit.value)}
              </div>
            ))}
          </div>
        </Modal>
      </div>
    );
  }

  return (
    <section className="sidebar-credit-card" aria-label="Credits">
      <div className="sidebar-credit-card__header">
        <span className="sidebar-credit-card__heading">
          <span className="sidebar-credit-card__heading-icon">
            <CircleDollarSign size={14} />
          </span>
          Credits
        </span>
        <span className="sidebar-credit-card__header-actions">
          <button
            type="button"
            className="sidebar-credit-refresh"
            aria-label="Refresh credits"
            title="Refresh credits"
            disabled={loading}
            onClick={() => getActivePlanDetails()}
          >
            <RefreshCw size={13} />
          </button>
        </span>
      </div>

      <div className="mt-2 text-[.675rem] font-medium text-[#94a3b8]">
        Remaining Balance
      </div>

      <div className="sidebar-credit-card__credits mt-2">
        {creditItems.map((credit) => (
          <div className="sidebar-credit-row" key={credit.label}>
            <span>{credit.label}</span>
            {renderCreditValue(credit.value)}
          </div>
        ))}
      </div>
    </section>
  );
}

export default SidebarCreditsCard;

